﻿/*-------------------------------------------------------
'   @module: User Dropdown
'---------------------------------------------------------*/


export class ArtUserDropdown {
    constructor() {
        this.userDropdownSelector = 'user-dropdown';
        this.userDropdownBtnSelector = `[data-user-dropdown]`;

        this.userDropdown = document.querySelector(`.${this.userDropdownSelector}`);

        if(this.userDropdown) {
            this.attachEventListener();
        }
    }

    attachEventListener() {
        this.userDropdown.addEventListener('click', e => {
            if(e.target.closest(this.userDropdownBtnSelector)) {
                this.toggleUserDropdown();
            }
        });
    }

    toggleUserDropdown() {
        this.userDropdown.classList.toggle(`${this.userDropdownSelector}--open`);
    }
}


new ArtUserDropdown();